<template>
  <collapsible-section title="PIM_PRODUCT-ACCORDION_TITLE-STOCK" :defaultOpen="defaultOpen">


    <!-- amountInStock -->
    <template v-if="pharmacy !== null">

      <!-- stockType / visibility -->
      <template v-if="pharmacy.erp === null">
        <form-input
          inputType="select"
          :showLabelInOptions="true"
          label="PIM-PRODUCT-VISIBILITY"
          :selectIsSearchable="true"
          v-model="productVisibilityWrapper"
          :isReadOnly="isReadonly"
          :selectOptions="apopointProductVisibility"
        ></form-input>
      </template>

      <template v-else>
        <form-input
          inputType="select"
          :showLabelInOptions="true"
          label="PIM-PRODUCT-VISIBILITY"
          :selectIsSearchable="true"
          v-model="productVisibilityWrapper"
          :isReadOnly="true"
          :selectOptions="apopointProductVisibility"
        ></form-input>
      </template>
      
      <form-input
        inputType="text"
        :label="'PIM-PRODUCT-AMOUNT_IN_STOCK' + labelSuffix"
        v-model="product.erp.amountInStock"
        :isReadOnly="product.erp.readonly"
      ></form-input>

      <template v-if="pharmacy.erp && product.erp.amountInStock && parseInt(product.erp.amountInStock) === 0">

        <div class="control">
          <div class="control-label">
            <label-name labelKey="PIM-PRODUCT-IGNORE_AMOUNT_IN_STOCK"></label-name>
          </div>
          <div class="control">
            <b-switch
              v-model.sync="amountInStockOverride"
              type="primary"
              size="small"
              :disabled="product.erp.readonly"
            ></b-switch>
          </div>
        </div>

      </template>

    </template>


    <ul class="otherValuesContainer" v-if="pharmacy === null">
      <li
        v-for="(val, key) in product.stockTypes"
        class="otherValues"
        v-if="key != 'pim' && val != ''"
      >
        <span class="key">
          <lang :labelKey="'PIM-PRODUCT-STOCK_TYPE-' + key"></lang
          >: </span
        ><br /><span class="value" v-html="val"></span><br />
      </li>
    </ul>

    <!-- Warehouse Entries -->
    <div
      class="control"
      v-if="
        product.warehouseEntries &&
        product.warehouseEntries.length > 0
      "
    >
      <div class="control-label">
        <label-name
          labelKey="PIM-PRODUCT-WAREHOUSES-AMOUNTS_IN_STOCK"
        ></label-name>
      </div>

      <ul
        class="control otherValuesContainer"
        style="padding-left: 0 !important"
      >
        <li
          class="otherValues"
          v-for="warehouse in product.warehouseEntries"
        >
          {{ warehouse.warehouse.name }}:
          {{ warehouse.amountInStock }}
        </li>
      </ul>
    </div>

  </collapsible-section>
</template>

<script>
import CollapsibleSection from "../../utils/CollapsibleSection.vue";

export default {
  name: "ProductSectionStock",

  components: {
    CollapsibleSection,
  },

  props: {
    product: { type: Object, required: true },
    pharmacy: { type: Object, default: null },
    isReadonly: { type: Boolean, default: false },
    labelSuffix: { type: String, default: "" },
    
    defaultOpen: { type: Boolean, default: false },
  },

  computed: {

    apopointProductVisibility() {
      return this.$store.getters.getTermsByTaxonomyRaw(
        "APOPOINT_PRODUCT_VISIBILITY"
      );
    },

    productVisibilityWrapper: {
      get() {
        return this.product.apopointVisibility === null
          ? null
          : this.apopointProductVisibility.find(
              (_) => _.id === this.product.apopointVisibility
            );
      },
      set(value) {
        this.product.apopointVisibility = value !== null ? value.id : null;
      },
    },

    amountInStockOverride: {
      get() {
        return this.product.erp && this.product.erp.amountInStockOverride == 1;
      },
      set(value) {
        if (this.product.erp) {
          this.product.erp.amountInStockOverride = value === true ? 1 : null;
        }
      },
    },


  },
};
</script>

<style scoped lang="scss">
.otherValuesContainer {
  padding-left: 10px;
  margin: 0 0 40px 0;
  display: block;
  border: none;

  li.otherValues {
    background: #f0f1f2;
    border-radius: 3px;
    margin-bottom: 3px;
    padding: 2px 5px;
    white-space: normal;

    .key {
      display: inline-block;
      font-weight: 400;
      overflow: hidden;
      margin-right: 8px;
      font-size: 11px;
      text-transform: uppercase;
    }

    .value {
      font-size: 11px !important;
      width: 440px;

      p {
        padding-bottom: 10px;
      }
    }
  }
}
</style>
